module.exports = __webpack_public_path__ + "static/case-messages-6e207f21339cdabab3fe95de4e190c01.png";